import { useNotification } from "@hooks/useNotification";
import { Users } from "@services/all.services";

function useEmailEmployeDuplicationCheck() {
    const { showError } = useNotification();

    const isPersonalEmailValid = async (email, withoutNotification = false) => {
        try {
            let userEmail = { email };
            const response = await Users.verifyExistEmail(userEmail);
            const isValid = !response.userAlreadyExist;
            if (!isValid && !withoutNotification) {
                showError("already_exists", { object: "emailUpper" });
            }
            return isValid;
        } catch (err) {
            console.error(err);
            showError("error_occured", {
                mode: "action_mode_verification",
                object: "emailsLower"
            });
            return false;
        }
    };

    return {
        isPersonalEmailValid
    }
}

export { useEmailEmployeDuplicationCheck }
export default useEmailEmployeDuplicationCheck;